import type { Curation } from "@schema/catalog.ts";
import { Spoiler } from "@/components/ui/Spoiler.tsx";
import { useCatalog } from "@/lib/catalog/context.tsx";
import styles from "./WhyItMatters.module.css";

/**
 * The editorial voice of the card. Essential/important entries explain why they
 * matter; everything else shows what skipping costs — the same line the cut
 * list leads with in the plan.
 *
 * "What you miss" is spoiler-gated. To be honest about the cost of skipping
 * something it has to name the payoff, which is precisely what a first-time
 * viewer planning their watch must not read by accident. The label stays
 * visible; only the answer is hidden.
 */
export function WhyItMatters({ curation }: { curation: Curation }) {
  // Read before the early return: hooks cannot run conditionally.
  const gated = useCatalog().project.features.spoilers;

  if (curation.whyItMatters) {
    return <p className={styles.why}>{curation.whyItMatters}</p>;
  }
  return (
    <div className={styles.skip}>
      <span className={styles.skipLabel}>If you skip it</span>
      {gated ? (
        <Spoiler label="Read what you miss">{curation.whatYouMissIfSkipped}</Spoiler>
      ) : (
        <span>{curation.whatYouMissIfSkipped}</span>
      )}
    </div>
  );
}
